import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigateRef } from '@/lib/navigationRef';

/**
 * Wires React Router's navigate into navigationRef.ts as early as possible —
 * BEFORE AuthProvider and the other top-level contexts. This matters for
 * cold-start push notification taps: PushNotificationInitializer used to set
 * the ref, but it lived under four nested providers, so a tap that arrived
 * before those providers settled would fall back to window.location.href
 * (a full page reload — what users described as "the app refreshes").
 *
 * Keep this component empty of providers / heavy logic so it mounts on first
 * paint after BrowserRouter.
 */
export const NavigateRefSetter = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigateRef(navigate);
  }, [navigate]);
  return null;
};
